



















































































































































































































import _ from 'lodash'
import { Component, Vue, Watch, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import { onlyNumber, validateCPF } from '@/utils/common'
import { AnestesistaHospital } from '@/types/_'
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentModalSolicitacaoCirurgiaAnestesistas extends Vue {
  $refs: { getInputSearch: HTMLInputElement, cadastroAnestesistaForm: any }

  anestesistasTableHeader: any[] = [
    { text: 'Nome', align: 'left', value: 'nome', sortable: false },
    { text: 'CRM', align: 'left', value: 'crm', sortable: false },
    { text: 'CNPJ', align: 'left', value: 'documento', sortable: false },
    { text: 'Vinculado ao hospital?', align: 'center', value: 'temVinculoHospital', sortable: false },
  ]

  get getInputSearch() { return this.getSolicitacaoCirurgiaStore.anestesistaSearchText }
  set getInputSearch(value: string) { this.getSolicitacaoCirurgiaStore.setAnestesistaSearchText(value) }

  loadAnestesistas: boolean = false
  get loadingAnestesistas() { return this.loadAnestesistas }
  set loadingAnestesistas(value: boolean) { this.loadAnestesistas = value }

  modalCadastrarAnestesista: boolean = false
  get showModalCadastrarAnestesista() { return this.modalCadastrarAnestesista }
  set showModalCadastrarAnestesista(value: boolean) { this.modalCadastrarAnestesista = value }

  selected: AnestesistaHospital = { id: '', nome: '', crm: '', temVinculoHospital: false }
  get selectedAnestesista() { return this.selected }
  set selectedAnestesista(value: AnestesistaHospital) { this.selected = value }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get showModalAnestesistas() { return this.getSolicitacaoCirurgiaStore.modal.listaDeAnestesistas }
  set showModalAnestesistas(value: boolean) { this.getSolicitacaoCirurgiaStore.setModal({ name: 'listaDeAnestesistas', value }) }

  cadastroAnestesistaForm: any = {
    valid: true,
    nome: [
      (v: any) => !!v || 'Campo obrigatório.',
      (v: any) => v.length >= 5 || 'O campo deve conter pelo menos 5 caracteres.',
    ],
    documento: [
      (v: any) => !!v || 'Campo obrigatório.',
      (v: any) => !!validateCPF(v) || 'Informe um CPF válido',
    ],
    crm: [
      (v: any) => !!v || 'Campo obrigatório.',
      (v: any) => v.length === 9 || 'O campo deve ter o formato: 123456-SP.',
    ],
  }

  novoAnestesista: any = { nome: '', documento: '', crm: '' }
  loadCadastrarAnestesista: boolean = false
  get loadingCadastrarAnestesista() { return this.loadCadastrarAnestesista }
  set loadingCadastrarAnestesista(value: boolean) { this.loadCadastrarAnestesista = value }

  get getAnestesistasApi() {
    return (
      this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.anestesiaDoHospital === 'Sim' && !!this.getSolicitacaoCirurgiaStore.anestesistas.length
        ? this.getSolicitacaoCirurgiaStore.anestesistas.filter((anestesista: any) => anestesista.temVinculoHospital)
        : this.getSolicitacaoCirurgiaStore.anestesistas) || []
  }

  get getPagina() {
    return this.getSolicitacaoCirurgiaStore.pagina
  }

  set getPagina(value: number) {
    this.getSolicitacaoCirurgiaStore.setPagina(value)
  }

  get getQtdPorPagina() {
    return this.getSolicitacaoCirurgiaStore.qtdPorPagina
  }

  set getQtdPorPagina(value: number) {
    this.getSolicitacaoCirurgiaStore.setQtdPorPagina(value)
  }

  get getTotalAnestesistas() {
    return this.getSolicitacaoCirurgiaStore.totalAnestesistas
  }

  get anestesistasLength() {
    return Math.ceil(this.getTotalAnestesistas / this.getQtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  async getResults(pagina: number) {
    this.loadingAnestesistas = true
    this.getPagina = pagina
    await this.getSolicitacaoCirurgiaStore.getAnestesistas()
    this.loadingAnestesistas = false
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  debounce = _.debounce(input => this.getSolicitacaoCirurgiaStore.getAnestesistas(), 700)

  search() {
    if (this.getInputSearch.length === 0) this.resetSearch()
    if (this.getInputSearch.length > 2) {
      this.getSolicitacaoCirurgiaStore.clearPagination()
      this.debounce(this.getInputSearch)
    }
  }

  resetSearch() {
    this.getInputSearch = ''
    this.getSolicitacaoCirurgiaStore.clearPagination()
    this.getSolicitacaoCirurgiaStore.clearAnestesistas()
  }

  resetSelectedAnestesista() {
    this.selectedAnestesista = { id: '', nome: '', crm: '', temVinculoHospital: false }
  }

  async cadastrarAnestesista() {
    this.loadingCadastrarAnestesista = true
    const isValid = this.$refs.cadastroAnestesistaForm.validate()
    if (!isValid) {
      this.loadingCadastrarAnestesista = false
      return
    }

    const payload: any = {
      nome: this.novoAnestesista.nome,
      documento: this.novoAnestesista.documento,
      crm: this.novoAnestesista.crm,
    }

    const request = await this.getSolicitacaoCirurgiaStore.postAnestesista(payload)
    EventBus.$emit('setSnackbar', {
      show: true,
      text: request.success ? 'Cadastrado com sucesso! Agora você pode selecioná-lo na lista.' : request.message,
      icon: request.success ? 'done' : 'warning',
      color: request.success ? '#2E7D32' : '#C62828',
      timeout: 5500,
    })
    this.showModalCadastrarAnestesista = false
    this.loadingCadastrarAnestesista = false
  }

  confirmar() {
    this.getSolicitacaoCirurgiaStore.setSolicitacaoAnestesista(this.selectedAnestesista.id ? { ...this.selectedAnestesista } : null)
    if (this.selectedAnestesista.id) this.$emit('anestesistaSelecionado', true)
    this.showModalAnestesistas = false
  }

  @Watch('showModalAnestesistas')
  onChangeShowModalAnestesistas(value: boolean) {
    setTimeout(() => {
      if (value) {
        this.$refs.getInputSearch.focus()
      } else {
        this.$refs.getInputSearch.blur()
        this.getInputSearch = ''
        this.getSolicitacaoCirurgiaStore.clearPagination()
        this.getSolicitacaoCirurgiaStore.clearAnestesistas()
        this.resetSelectedAnestesista()
        this.getSolicitacaoCirurgiaStore.setModal({ name: 'listaDeAnestesistas', value: false })
      }
    }, 100)
  }

  @Watch('showModalCadastrarAnestesista')
  onChangeShowModalCadastrarAnestesista(value: boolean) {
    if (!value) {
      this.novoAnestesista = { nome: '', documento: '', crm: '' }
      this.$refs.cadastroAnestesistaForm.resetValidation()
    }
  }
}

